import Utils from '../utils';


// Submit unlockSearch form
document.addEventListener('submit', async (ev) => {
    const form = ev.target as HTMLFormElement;
    if (form && form.id === 'unlockSearch') {
        ev.preventDefault();
        Utils.setOverlay(true); 
        try {
            const data = Utils.getData(ev);
            const response = await Utils.emit <{url: string}>({ url: '/unlock', data });
            if (response.url) window.location.href = response.url;
        } finally {
            Utils.setOverlay(false); 
            
        }
   
    }
});


// Input validation
const inputs = document.querySelectorAll('#unlockSearch #usuario');
const errorMessage = document.getElementById('error');

const validarInput = (ev: Event) => {
    const input = ev.target as HTMLInputElement;
    const value = input.value;
    const hasSpecialChars = /[^a-zA-Z0-9-]/.test(value);
    const isTooLong = value.length > 20;

    if (hasSpecialChars || isTooLong) {
        if (errorMessage) errorMessage.style.display = 'block';
        input.value = 'false';
    } else {
        if (errorMessage) errorMessage.style.display = 'none';
        input.value = 'true';
    }
};

inputs.forEach((input) => {
    input.addEventListener('keyup', validarInput);
    input.addEventListener('blur', validarInput);
});

// refresh captcha
document.addEventListener('click', async (ev) => {
    const target = ev.target as HTMLElement;
    if (target && target.id === 'getCaptcha') {
        await Utils.getNewCaptcha('unlock/utils');
    }
});

